export function stringBefore(string, substring) {
  let indexOf = string.indexOf(substring);
  return indexOf === -1 ? string : string.substr(0, indexOf);
}

export function stringIsBlank(s) {
  return _.isEmpty(_.trim(s));
}